import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { useNavigate } from 'react-router-dom';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';

import reimg1 from "../assets/images/reimg1.png";
import reimg2 from "../assets/images/reimg2.png";
import reimg3 from "../assets/images/reimg3.png";

import tabbg from "../assets/images/tab_01.png"


const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});




// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg2, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];




const HomeTop = () => {

    return (

        <Box sx={img} >
            {/* logo */}


            <Grid container spacing={2} direction='row'  justifyContent='center' alignItems={'center'} sx={{overflow:'hidden', height:200, textAlign:'center' }}>
                {/* <Grid item sx={{ width: '45%', ml: 1, pt: 0 }}>
                    <Img alt="care" src={reTopImg} />
                </Grid> */}
                <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
                    <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
                        심리상담
                    </Typography>
                    <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
                        예약서비스
                    </Typography>
                </Grid>
            </Grid>
        </Box>

    );
}

const img ={ 
    display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }
  


export default HomeTop;

